/**
 * @fileoverview PATCH handler for the "/api/calculated_filters/:app_group_id/archive" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { patchApiCalculatedFiltersAppGroupIdArchiveCacheKeys } from "./constants";
import type {
  PatchApiCalculatedFiltersAppGroupIdArchiveProps,
  PatchApiCalculatedFiltersAppGroupIdArchiveResult,
} from "./types";

export const patchApiCalculatedFiltersAppGroupIdArchive = reactQueryMutationAdapter(
  patchApiCalculatedFiltersAppGroupIdArchiveCacheKeys,
  (
    props: PatchApiCalculatedFiltersAppGroupIdArchiveProps
  ): Promise<PatchApiCalculatedFiltersAppGroupIdArchiveResult> => {
    const { app_group_id: appGroupId, calculated_filter_ids: calculatedFilterIds } = props;
    return fetch(
      `/api/calculated_filters/${appGroupId}/archive`,
      "PATCH",
      { calculated_filter_ids: calculatedFilterIds },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
